module.exports = __webpack_public_path__ + "img/score-img.e8b765b8.png";